import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { Box } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'

const EmprovePricing = ({ data, loading, error }) => {
  const theme = useTheme()

  if (loading)
    return (
      <Box
        height={28}
        width={0.25}
        borderRadius="borderRadius"
        my={3}
        bgcolor={theme.palette.grey['50']}
      />
    )
  if (error) {
    return (
      <Box fontWeight="fontWeightMedium">
        <FormattedMessage
          id="PRICE_UNAVAILABLE"
          defaultMessage="Price Unavailable"
        />
      </Box>
    )
  }
  const pricing = data?.getPricingForProduct?.materialPricing[0]
  if (!pricing?.price) {
    return (
      <Box fontWeight="fontWeightMedium">
        <FormattedMessage
          id="PRICE_UNAVAILABLE"
          defaultMessage="Price Unavailable"
        />
      </Box>
    )
  }
  return (
    <Box fontWeight="fontWeightMedium">
      <FormattedNumber
        style="currency"
        currencyDisplay="symbol"
        currency={pricing?.currency}
        value={pricing?.price as number}
      />
    </Box>
  )
}

export default EmprovePricing
